import CampaignsPage from "./pages/CampaignsPage";
import ComposeCampaignPage from "./pages/ComposeCampaignPage";
import CampaignDetailPage from "./pages/CampaignDetailPage";

/**
 * Secretariat mail-out.
 *
 * Reading the module and composing in it are separate grants, because a
 * mail-out reaches the whole membership at once and cannot be recalled. The
 * compose screens therefore ask for `mail_campaigns.manage` on top of access,
 * while the act of SENDING is gated on `mail_campaigns.send` at the button —
 * a route guard cannot express "may open this page but not press that".
 *
 * super_admin bypasses all of it in RequirePermission, so no entry here needs
 * to name it.
 */
export const mailRoutes = [
  { path: "/admin/mail/campaigns",     element: <CampaignsPage />,       roles: ["admin"], perms: ["mail_campaigns.access"] },
  { path: "/admin/mail/campaigns/:id", element: <CampaignDetailPage />,  roles: ["admin"], perms: ["mail_campaigns.access"] },

  { path: "/admin/mail/compose",       element: <ComposeCampaignPage />, roles: ["admin"], perms: ["mail_campaigns.manage"] },
  { path: "/admin/mail/compose/:id",   element: <ComposeCampaignPage />, roles: ["admin"], perms: ["mail_campaigns.manage"] },
];
